import { useTranslation } from 'react-i18next';

import { Form, FormInstance, Grid, Input, Select } from '@arco-design/web-react';
import styled from 'styled-components';
import { GrayBox, ItemTitle } from '../../tools';
import { VolumeItem, VolumeMountsProps, VolumeMountType } from '../_hooks';
import i18n from '@/i18n';

const Row = Grid.Row;
const Col = Grid.Col;
const FormList = Form.List;
const FormItem = Form.Item;

const { NotMount, ReadOnly, ReadWrite } = VolumeMountType;

// 使用泛型定义 props
interface AddedPodsProps<T extends VolumeMountsProps = VolumeItem> {
  /** 类型安全: 约束了 from 实例只能从 VolumeMountsProps 中获取, 且保证了传参正常
   *  说人话就是: form.getFieldValue('volumeMounts') 只能传入 "volumeMounts" 字段
   *  powered by AI
   */
  form: FormInstance<T>;
}

/**
 * 这是在存储设置里面已经添加的容器列表
 */
export function AddedPods<T extends VolumeMountsProps = VolumeItem>({ form }: AddedPodsProps<T>) {
  // 获取所有挂载的值

  const { t } = useTranslation();
  const volumeMountValues =
    (form.getFieldValue('volumeMounts') as VolumeMountsProps['volumeMounts']) || [];

  // 待选项
  const options = [
    {
      value: NotMount,
      label: t('common:do.not.mount'),
    },
    {
      value: ReadOnly,
      label: t('common:read.only'),
    },
    {
      value: ReadWrite,
      label: t('common:read.write'),
    },
  ];

  return (
    <PodListBox>
      <FormList field="volumeMounts">
        {(fields) => {
          return fields.map((item, index) => {
            return (
              <GrayBox key={index}>
                <ItemTitle>{volumeMountValues?.[index]?.containerName}</ItemTitle>
                <Row gutter={8}>
                  <Col span={12}>
                    <FormItem field={`${item.field}.mountType`}>
                      <Select
                        showSearch
                        options={options}
                        getPopupContainer={() => document.body}
                      />
                    </FormItem>
                  </Col>
                  <Col span={12}>
                    <FormItem field={`${item.field}.mountPath`}>
                      <Input placeholder={t('common:mount.path')} />
                    </FormItem>
                  </Col>
                </Row>
              </GrayBox>
            );
          });
        }}
      </FormList>
    </PodListBox>
  );
}

/** ============================ 样式 ==================================== */
const PodListBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
